module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('color-picker', {
    attrs: {
      "label": _vm.$t('edit.sidebar.background_color'),
      "id": "triggerButtonBgColor",
      "value": _vm.boxConfig.trigger_button.style.backgroundColor,
      "change": _vm.onColorChange,
      "move": _vm.onMove
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-a31e6402!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/triggerbutton/BackgroundColor.vue
 ** module id = 893
 ** module chunks = 1
 **/